// Instant (AJAX) filters voor collection + search.
// Fetcht de main-section opnieuw via ?section_id=... en vervangt
// alleen de inhoud van [data-facets]. Werkt met Shopify Search & Discovery.
(() => {
  const container = document.querySelector('[data-facets]');
  if (!container) return;

  const sectionId = container.getAttribute('data-facets-id');
  let controller = null;

  const stripSection = (url) => {
    const u = new URL(url, location.origin);
    u.searchParams.delete('section_id');
    return u.toString();
  };

  const render = async (url, { scroll = false } = {}) => {
    const fetchUrl = new URL(url, location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);

    if (controller) controller.abort();
    controller = new AbortController();
    container.setAttribute('aria-busy', 'true');

    try {
      const res = await fetch(fetchUrl.toString(), { signal: controller.signal });
      if (!res.ok) { location.assign(stripSection(url)); return; }
      const text = await res.text();
      const fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-facets]');
      if (!fresh) { location.assign(stripSection(url)); return; }

      container.innerHTML = fresh.innerHTML;
      container.setAttribute('aria-busy', 'false');
      document.dispatchEvent(new CustomEvent('sj:content-replaced', { detail: { container } }));
      history.pushState({ facets: true }, '', stripSection(url));
      if (scroll) container.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (err) {
      if (err.name !== 'AbortError') {
        container.setAttribute('aria-busy', 'false');
        location.assign(stripSection(url));
      }
    }
  };

  const loadMore = async (link) => {
    if (link.getAttribute('aria-busy') === 'true') return;
    const grid = container.querySelector('.catalog-grid');
    const wrap = link.closest('[data-load-more-wrap]');
    const fetchUrl = new URL(link.href, location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);
    link.setAttribute('aria-busy', 'true');
    link.textContent = 'Laden…';

    try {
      const res = await fetch(fetchUrl.toString());
      if (!res.ok) throw new Error(res.status);
      const fresh = new DOMParser().parseFromString(await res.text(), 'text/html').querySelector('[data-facets]');
      const freshGrid = fresh && fresh.querySelector('.catalog-grid');
      if (!grid || !freshGrid) throw new Error('geen grid');

      // Shuffle, wishlist enz. op de nieuwe kaarten laten draaien vóór ze in beeld komen.
      document.dispatchEvent(new CustomEvent('sj:content-replaced', { detail: { container: fresh } }));
      const first = freshGrid.firstElementChild;
      grid.append(...freshGrid.children);
      const freshWrap = fresh.querySelector('[data-load-more-wrap]');
      if (freshWrap) {
        // Server telt alleen de eigen pagina; de echte stand is wat er nu in het grid staat.
        const shown = grid.querySelectorAll(':scope > :not([data-promo])').length;
        const total = Number(freshWrap.dataset.total) || shown;
        freshWrap.querySelector('[data-load-more-shown]').textContent = shown;
        freshWrap.querySelector('[data-load-more-bar]').style.width = Math.min(100, (shown / total) * 100) + '%';
        wrap.replaceWith(freshWrap);
      } else wrap.remove();
      // Focus naar de eerste nieuwe kaart, zodat toetsenbord en screenreader verder gaan waar het nieuwe begint.
      const focusable = first && (first.matches('a, button') ? first : first.querySelector('a, button'));
      if (focusable) focusable.focus({ preventScroll: true });
    } catch (err) {
      location.assign(link.href);
    }
  };

  const urlFromForm = (form) => {
    const params = new URLSearchParams();
    new FormData(form).forEach((value, key) => {
      if (String(value).trim() !== '') params.append(key, value);
    });
    const u = new URL(form.getAttribute('action') || location.href, location.origin);
    u.search = params.toString();
    return u.toString();
  };

  // Checkbox / price change + sort select
  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-facets-form]');
    if (form && container.contains(form)) { render(urlFromForm(form)); return; }

    const sort = e.target.closest('[data-facet-sort]');
    if (sort) {
      const u = new URL(location.href);
      u.searchParams.set('sort_by', sort.value);
      render(u.toString());
    }
  });

  // Enter / no-JS submit
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-facets-form]');
    if (form && container.contains(form)) { e.preventDefault(); render(urlFromForm(form)); }
  });

  // Mobiele drawer open/dicht (state op <html> zodat het AJAX-render overleeft)
  const overlay = document.querySelector('[data-facets-overlay]');
  const setDrawer = (open) => {
    document.documentElement.classList.toggle('facets-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    if (overlay) overlay.hidden = !open;
    const toggle = document.querySelector('[data-facets-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-facets-toggle]')) {
      setDrawer(!document.documentElement.classList.contains('facets-open'));
      return;
    }
    if (e.target.closest('[data-facets-close]') || e.target.closest('[data-facets-overlay]')) {
      setDrawer(false);
      return;
    }

    // "Toon meer" binnen een filter
    const facetMore = e.target.closest('[data-facet-more]');
    if (facetMore) {
      const expanded = facetMore.getAttribute('aria-expanded') === 'true';
      const list = facetMore.parentElement.querySelector('[data-facet-list]');
      list.querySelectorAll('.facet__row--extra').forEach((li) => { li.hidden = expanded; });
      facetMore.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      facetMore.querySelector('.facet__more-show').hidden = !expanded;
      facetMore.querySelector('.facet__more-hide').hidden = expanded;
      return;
    }

    // Meer laden: volgende pagina onder het grid plakken. URL blijft staan, anders
    // toont een reload alleen die laatste pagina.
    const more = e.target.closest('[data-load-more]');
    if (more && container.contains(more)) {
      e.preventDefault();
      loadMore(more);
      return;
    }

    // Chip verwijderen, wis-alles, paginering
    const link = e.target.closest('[data-facet-remove], [data-facet-clear], [data-facets-pagination] a');
    if (link && container.contains(link)) {
      e.preventDefault();
      render(link.href, { scroll: !!link.closest('[data-facets-pagination]') });
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') setDrawer(false);
  });

  // Zoeken binnen een lange filterlijst (client-side)
  document.addEventListener('input', (e) => {
    const search = e.target.closest('[data-facet-search]');
    if (!search) return;
    const details = search.closest('.facet');
    const list = details.querySelector('[data-facet-list]');
    const more = details.querySelector('[data-facet-more]');
    const q = search.value.trim().toLowerCase();
    list.querySelectorAll('li').forEach((li) => {
      const match = !q || (li.dataset.facetValue || '').includes(q);
      li.hidden = !match || (!q && li.classList.contains('facet__row--extra') && (!more || more.getAttribute('aria-expanded') !== 'true'));
    });
    if (more) more.hidden = q.length > 0;
  });

  window.addEventListener('popstate', () => render(location.href));
})();

// Raster/lijst-weergave op de catalogusgrids (snippets/view-toggle.liquid).
// De staat staat op <html> zodat hij de AJAX-render van [data-facets] overleeft;
// localStorage onthoudt hem tussen pagina's. Delegatie, dus verse knoppen na een
// filterwissel werken zonder herbinding.
(() => {
  const KEY = 'sj:catalog-view';
  const root = document.documentElement;

  const stored = () => {
    try { return localStorage.getItem(KEY); } catch (err) { return null; }
  };

  // Zelfde standaard als het inline script in snippets/view-toggle.liquid: zonder
  // eigen keuze is lijst de mobiele weergave en raster de desktopweergave.
  const fallback = () => (window.matchMedia('(max-width: 767px)').matches ? 'list' : 'grid');

  const sync = () => {
    const view = root.dataset.catalogView === 'list' ? 'list' : 'grid';
    document.querySelectorAll('[data-view-set]').forEach((btn) => {
      btn.setAttribute('aria-pressed', btn.dataset.viewSet === view ? 'true' : 'false');
    });
  };

  const apply = (view) => {
    root.dataset.catalogView = view === 'list' ? 'list' : 'grid';
    sync();
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-view-set]');
    if (!btn) return;
    const view = btn.dataset.viewSet === 'list' ? 'list' : 'grid';
    try { localStorage.setItem(KEY, view); } catch (err) {}
    apply(view);
  });

  // Na een facets-render staan er nieuwe knoppen; alleen aria-pressed bijwerken,
  // de weergave zelf hangt al aan <html>.
  document.addEventListener('sj:content-replaced', sync);

  apply(root.dataset.catalogView || stored() || fallback());
})();
